import { Flag } from "lucide-react";
import { Link } from "react-router";

type CorrectionSubject = "COMPANY" | "PERSON" | "INSOLVENCY" | "VAT" | "SCORE";

interface Props {
	subject: CorrectionSubject;
	companyIco?: string;
	companyName?: string;
	personId?: string;
	targetRecordId?: string;
	returnTo?: string;
	className?: string;
}

export function ReportDataIssueLink({
	subject,
	companyIco,
	companyName,
	personId,
	targetRecordId,
	returnTo,
	className = "btn btn-ghost btn-sm",
}: Props) {
	const params = new URLSearchParams({ subject });
	if (companyIco) params.set("companyIco", companyIco);
	if (companyName) params.set("companyName", companyName);
	if (personId) params.set("personId", personId);
	if (targetRecordId) params.set("targetRecordId", targetRecordId);
	if (returnTo) params.set("returnTo", returnTo);

	return (
		<Link to={`/nahlasit-udaj?${params.toString()}`} className={className} rel="nofollow">
			<Flag className="h-4 w-4" />
			Nahlásit nesprávný údaj
		</Link>
	);
}
